<template>
  <!-- Login Component -->
  <div>
    <div class="page-header">
      <v-layout row align-center>
        <v-icon x-large>mdi-login</v-icon>
        <h1 class="page-title">Login</h1>
      </v-layout>
    </div>
    <v-form v-model="valid">
      <v-row>
        <v-col cols="12" lg="6" md="6" sm="12">
          <v-text-field
            required
            label="Username"
            prepend-icon="mdi-account-circle"
            v-model="user.userName"
            :rules="userNameRules"
          />
        </v-col>
        <v-col cols="12" lg="6" md="6" sm="12">
          <v-text-field
            label="Password"
            v-model="user.password"
            :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
            prepend-icon="mdi-lock"
            :type="showPassword ? 'text' : 'password'"
            @click:append="showPassword = !showPassword"
            :rules="passwordRules"
          />
        </v-col>
      </v-row>
      <v-row>
        <v-spacer></v-spacer>
        <v-btn outlined :disabled="!valid" @click="onLogin"
          >Login</v-btn
        >
      </v-row>
      <br />
      <v-row>
        <v-spacer></v-spacer>
        <v-btn outlined color="accent" @click="onRegister">Register</v-btn>
        <v-btn outlined color="accent" @click="onResetPassword"
          >Reset Password</v-btn
        >
      </v-row>
    </v-form>
    <div>
      <statusalert ref="alert" @closed="onStatusAlertClosed"></statusalert>
    </div>
  </div>
</template>

<script>
import store from '@/store/index.js'
import router from '@/router/index.js'
import AccountService from '@/services/api/AccountService.js'
import statusalert from '../../components/StatusAlert'

export default {
  name: 'Login',
  components: {
    statusalert
  },
  store: store,
  router: router,
  data: () => ({
    passwordRules: [v => !!v || 'Password is required'],
    showPassword: false,
    user: {
      userName: '',
      password: ''
    },
    userNameRules: [v => !!v || 'Username is required'],
    valid: false
  }),

  methods: {
    displayAlert() {
      this.$refs.alert.displayResult(this.result)
    },
    
    onLogin() {
      var me = this
      AccountService.login(this.user)
        .then(result => {
          me.result = result
          if(result.status === 200) {
            var token = me.parseToken(result.data)
            store.commit('loginUser', token)
            var user = me.$store.getters.getName
            me.result = {
              isValid: true,
              statusCode: result.status,
              errors: [user + ' logged in']
            }
            var url = me.$store.getters.getReturnUrl
            if (url.length > 0) {
              store.commit('setReturnUrl', '')
              router.push(url)
            }
          }
        })
        .catch(error => {
          console.log(error)
          me.result = {
            isValid: false,
            statusCode: error.response.status,
            errors: [error.response.data]
          }
        })
        .finally(() => {
          store.commit('notLoading')
          this.displayAlert()
        })
    },
    onRegister() {
      router.push('/Account/Register')
    },
    onResetPassword() {
      router.push('/Account/Reset')
    },
    onStatusAlertClosed() {
      if (this.result.statusCode < 300 ) {
        if (this.$store.getters.getMemberId > 0) {
          router.push('/Account/Home')
        } else {
          router.push('/Account/Profile')
        }
      }
    },
    parseToken(token) {
      var base64Url = token.split('.')[1]
      var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/')
      var jsonPayload = decodeURIComponent(
        atob(base64)
          .split('')
          .map(function(c) {
            return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2)
          })
          .join('')
      )

      return JSON.parse(jsonPayload)
    }
  }
}
</script>
